import request from '@/utils/request'

let ShareApi = {
  // 获取分享商品列表
  getsharegoodsList(data) {
    return request._post('/shop/plus.sharepolite.sharepolite/getShareGoodsList', data);
  },
  // 获取分享商品
  getsharegoods(data) {
    return request._post('/shop/plus.sharepolite.sharepolite/getShareGoods', data);
  },
  // 获取设置属性
  getset(data) {
    return request._post('/shop/plus.sharepolite.sharepolite/getSet', data);
  },

  //修改设置
  set(data) {
    return request._post('/shop/plus.sharepolite.sharepolite/editSet', data);
  },

  // 条件查询分享记录
  queryShareRecord(data) {
    return request._post('/shop/plus.sharepolite.sharepolite/queryShareRecord', data);
  },
  // 查询类型不为分享的商品
  queryNoShareGoods(data) {
    return request._post('/shop/plus.sharepolite.sharepolite/quertyNoShareGoods', data);
  },
  // 修改单一分享商品属性
  editShareGoods(data) {
    return request._post('/shop/plus.sharepolite.sharepolite/editShareGoods', data);
  },
  // 添加分享商品
  addShareGoods(data) {
    return request._post('/shop/plus.sharepolite.sharepolite/addShareGoods', data);
  }
}
export default ShareApi;



// WEBPACK FOOTER //
// ./src/api/sharepolite.js